import React, { useEffect, useState } from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import TextField from '../Base/TextField/TextField';
import Select, { SelectValue } from '../Base/Select/Select';
// @ts-ignore
import styles from './PhoneNumberField.module.scss';
import { joinClasses } from '../../Utils/className.util';
import useTermItemSelect from '../../Modules/Term/hooks/useTermItemSelect';
import { useEffectAsync } from '../../helpers';
import { useAppContext } from '../../Services/AppContext';

interface PhoneNumberInputProps {
	onChange?: (phoneNumber: string) => void;
	value?: string;
	disabled?: boolean;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
	onChange,
	value,
	disabled = false,
}) => {
	const { phonePrefix } = useAppContext();
	const [prefixes, setPrefixes] = useState<any[]>([]);
	const [prefix, setPrefix] = useState<SelectValue | undefined>({
		label: phonePrefix,
		value: phonePrefix,
	});
	const [number, setNumber] = useState<string | undefined>(undefined);
	const { termItemSelectOptions } = useTermItemSelect({
		termType: 'phone_prefixes',
		take: 999,
		labelTransform: item => {
			return item.value!;
		},
	});

	useEffectAsync(async () => {
		setPrefixes(await termItemSelectOptions());
	}, []);

	useEffect(() => {
		if (prefix?.label && number) {
			const phoneNumber = prefix?.label + '' + number;
			onChange?.(phoneNumber);
		}
	}, [prefix, number]);

	useEffect(() => {
		let parsedPhoneNumber = parsePhoneNumber(value || '');
		if (!parsedPhoneNumber) {
			parsedPhoneNumber = parsePhoneNumber(`${phonePrefix}${value}`);
		}
		if (
			parsedPhoneNumber?.nationalNumber &&
			parsedPhoneNumber?.nationalNumber !== number
		) {
			setNumber(parsedPhoneNumber.nationalNumber);
		}
		if (
			parsedPhoneNumber?.countryCallingCode &&
			parsedPhoneNumber?.countryCallingCode !== prefix?.value
		) {
			setPrefix({
				value: `+${parsedPhoneNumber.countryCallingCode}`,
				label: `+${parsedPhoneNumber.countryCallingCode}`,
			});
		}
	}, [value]);

	const handlePrefixChange = (item: SelectValue) => {
		setPrefix(item);
	};

	const handleNumberChange = (text: string) => {
		setNumber(text);
	};

	return (
		<div className={joinClasses([styles.container, 'phoneNumberField'])}>
			<div className={joinClasses([styles.prefix, 'prefix'])}>
				<Select
					options={prefixes}
					onChange={handlePrefixChange}
					value={prefix}
					disabled={disabled}
					isSearchable
				/>
			</div>
			<div className={joinClasses([styles.number, 'number'])}>
				<TextField
					onChange={handleNumberChange}
					value={number}
					type='tel'
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

export default PhoneNumberInput;
